import { LinkType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { RootPageState } from '@dtx-company/inter-app/src/redux/types'
import { usePageSelector } from '@dtx-company/inter-app/src/hooks/usePageSelector'

export function useGetPreviewLink(): LinkType | null {
  return usePageSelector((state: RootPageState) => state.linkEditReducer.previewLink)
}
